import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    subscription_plans: [],
    published_subscription_plans: []
  },
  actions: actions,
  mutations: mutations,
  getters: getters
}
